export const STATIC_OPTIONS = {
  gzip: true,
  maxage: 365 * 24 * 60 * 60 * 1000,
};

export const FIVE_SECONDS_IN_SECONDS = 5;
export const ONE_MINUTE_IN_SECONDS = 60 * 1;
export const TWO_MINUTES_IN_SECONDS = 60 * 2;
export const FIVE_MINUTES_IN_SECONDS = 60 * 5;
export const TEN_MINUTES_IN_SECONDS = 60 * 10;

export const ONE_HOUR_IN_SECONDS = 60 * 60;
export const TWELVE_HOUR_IN_SECONDS = 60 * 60 * 12;

export const THREE_SECONDS_IN_MILLISECONDS = 1000 * 60 * 3;
export const ONE_MINUTE_IN_MILLISECONDS = 1000 * 60;
export const FIVE_MINUTES_IN_MILLISECONDS = 1000 * 60 * 5;
export const TEN_MINUTES_IN_MILLISECONDS = 1000 * 60 * 10;

export const ONE_HOUR_IN_MILLISECONDS = 1000 * 60 * 60;
export const TWELVE_HOUR_IN_MILLISECONDS = 1000 * 60 * 60 * 12;

export const NOTIFICATION_TIMEOUT = THREE_SECONDS_IN_MILLISECONDS;

export const REDUX_STORE = '__NEXT_REDUX_STORE__';

export const HEADER_HEIGHT = 150 + 89; //banner + menu

export const PADDING_FROM_HEADER = 24;

export const TRIGGER_WORDS = [
  'Facebook',
  'Фейсбук',
  'Фэйсбук',
  'fb.com',
  'fb.me',
  ' FB ',
  ' FB-',
  'Instagram',
  'instagram.com',
  ' IGTV ',
  ' IGTV-',
  'Инстаграм',
  'Meta Platforms',
  ' Meta ',
  ' Meta-',
  ' Мета ',
  ' Мета-',
];

export const META_DISCLAIMER =
  'Meta признана экстремистской организацией и запрещена в России, также под запрет попали действия её дочерних проектов Facebook и Instagram.';

export const AUTH_FIELDS_NAMES = {
  NAME: 'name',
  PHONE: 'phone',
  CODE: 'code',
};

export const AUTH_FIELDS = [AUTH_FIELDS_NAMES.PHONE];

export const PHONE_MASK = [
  '+',
  '7',
  ' ',
  '(',
  /[1-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
